const WORKSPACE_ID_KEY = 'needl_km_app_workspace_id' as const;

export const getActiveWorkspaceId = (): string | null => {
  return localStorage.getItem(WORKSPACE_ID_KEY);
};

export const setActiveWorkspaceId = (workspaceId: string): void => {
  localStorage.setItem(WORKSPACE_ID_KEY, workspaceId);
};

export const clearActiveWorkspaceId = (): void => {
  localStorage.removeItem(WORKSPACE_ID_KEY);
};
